// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class ExtEnrollmentPatientLookupResultModel {
    static getAttributeTypeMap() {
        return ExtEnrollmentPatientLookupResultModel.attributeTypeMap;
    }
}
ExtEnrollmentPatientLookupResultModel.discriminator = undefined;
ExtEnrollmentPatientLookupResultModel.additionalProperties = false;
ExtEnrollmentPatientLookupResultModel.attributeTypeMap = [
    {
        "name": "patientId",
        "baseName": "patientId",
        "type": "string"
    },
    {
        "name": "memberNumber",
        "baseName": "memberNumber",
        "type": "string"
    },
    {
        "name": "enrollments",
        "baseName": "enrollments",
        "type": ""
    },
];
//# sourceMappingURL=extEnrollmentPatientLookupResultModel.js.map